import { render, staticRenderFns } from "./canceled_orders.vue?vue&type=template&id=3c9de5c4&"
import script from "./canceled_orders.vue?vue&type=script&lang=js&"
export * from "./canceled_orders.vue?vue&type=script&lang=js&"
import style0 from "./canceled_orders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports